import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ReadinessScore from './ReadinessScore';
import { BaseButton, CloseButton, useAuth } from '@repo/common';

import { ReactComponent as HumanIcon } from '@repo/common/assets/icons/28px/icon_28px_human.svg';
import { ReactComponent as CouponIcon } from '@repo/common/assets/icons/16px/icon_16px_payment-coupon_outline.svg';

const UserInfoBottomSheetModal = ({ isOpen, onClose }) => {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);
  const [animating, setAnimating] = useState(false);

  const getStepKey = (step) => `step ${String(step).padStart(2, '0')}`;
  const userStep = getStepKey(user?.step) || 'step 01';

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setAnimating(true));
      });
    } else {
      setAnimating(false);
      const timer = setTimeout(() => setVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!visible) return null;

  return ReactDOM.createPortal(
    <div
      className='fixed inset-0 z-[1000] flex items-end justify-center'
      style={{
        backgroundColor: animating ? 'rgba(23, 20, 16, 0.64)' : 'transparent',
        transition: 'background-color 0.3s ease',
      }}
      onClick={onClose}
    >
      <div
        className='w-full bg-grayscale-gray00 rounded-t-[40px] pt-6 px-10 pb-[60px] flex flex-col'
        style={{
          transform: animating ? 'translateY(0)' : 'translateY(100%)',
          transition: 'transform 0.3s ease',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className='flex items-end justify-end pb-2'>
          <CloseButton type='light' size='w-8 h-8' onClick={onClose} />
        </div>

        <div className='flex items-center gap-4 pb-9'>
          {user?.profileUrl ? (
            <img
              src={user.profileUrl}
              alt='profile'
              className='w-[100px] h-[100px] rounded-[20px] object-cover'
              style={{
                outline: '2px solid rgba(198, 249, 233, 0.20)',
                outlineOffset: '-2px',
              }}
            />
          ) : (
            <HumanIcon className='w-[100px] h-[100px] text-grayscale-gray06' />
          )}
          <div className='flex flex-col items-start justify-center gap-1 flex-1'>
            <div className='typo-title2 text-green-deep05'>
              {user?.firstName} {user?.lastName}
            </div>
            <div className='typo-b14Strong'>
              <span className='text-grayscale-gray03'>Lv </span>
              <span className='text-green-deep04'>{userStep}</span>
            </div>
            <div className='relative inline-flex items-end ml-auto'>
              <BaseButton
                icon={<CouponIcon />}
                type='text_basic'
                size='s'
                gap='gap-0.5'
              >
                Coupon
              </BaseButton>
              <span className='absolute top-[6px] right-[5px] w-[5px] h-[5px] rounded-full bg-purple-purple05' />
            </div>
          </div>
        </div>

        <ReadinessScore forceShow />
      </div>
    </div>,
    document.body
  );
};

export default UserInfoBottomSheetModal;
